export const selectSectorWorkflow = (state) =>
  state.quoteCreate.sectorWorkflow;

export const selectSectorStep = (state) =>
  state.quoteCreate.sectorWorkflow.step;

export const selectSectorComplete = (state) =>
  state.quoteCreate.sectorWorkflow.isComplete;

export const selectSquareft = (state) =>
  state.quoteCreate.sectorWorkflow.squareft;

export const selectCategory = (state) =>
  state.quoteCreate.sectorWorkflow.category;

export const selectPlace = (state) =>
  state.quoteCreate.sectorWorkflow.places;

export const selectServiceItem = (state) =>
  state.quoteCreate.sectorWorkflow.service;

export const selectAreas = (state) =>
  state.quoteCreate.sectorWorkflow.areas;

export const selectAreaByUid = (uid) => (state) => {
  const wf = state.quoteCreate.sectorWorkflow;

  // Main areas
  let found = wf.areas.find(a => a.uid === uid);

  if (found) return found;

  // Other areas
  found = wf.otherAreas.find(a => a.uid === uid);

  return found || null;
};

// OTHER AREAS

export const selectOtherAreas = (state) => state.quoteCreate.sectorWorkflow.otherAreas

// OBJECTS

export const selectObjects = (state) =>
  state.quoteCreate.sectorWorkflow.objects;

export const selectIsObjectSelected = (uid: string) => (state) =>
  state.quoteCreate.sectorWorkflow.objects.some(
    (obj) => obj.uid === uid
  );

// SPECIAL REQUESTS

export const selectSpecialRequests = (state) =>
  state.quoteCreate.sectorWorkflow.specialRequests;

export const selectIsSpecialRequestSelected =
  (uid: string) => (state) =>
    state.quoteCreate.sectorWorkflow.specialRequests.some(
      (req) => req.uid === uid
    );
